import { post, get, del} from "../http";

export const dashboardInfoUrl = () => get("/dashboard/report/class-wise/student");
export const dashboardGenderWiseStaffInfoUrl = () => get("/dashboard/report/gender-wise/staff");
export const dashboardGenderWiseStudentInfoUrl = () => get("/dashboard/report/gender-wise/student");

